import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Content",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "8.21",
      cy: "8.21",
      r: ".64"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.21 9.98c-.98 0-1.78-.8-1.78-1.78s.8-1.78 1.78-1.78 1.78.8 1.78 1.78-.8 1.78-1.78 1.78m0-2.28c-.28 0-.51.23-.51.51s.23.51.51.51.51-.23.51-.51-.23-.51-.51-.51M13.92 15.57c-.75 0-1.5-.28-2.06-.85l-1.03-1.03a.653.653 0 0 0-.9 0l-1.55 1.55c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62l1.55-1.55c1.1-1.1 3.03-1.1 4.13 0l1.03 1.03c.25.25.65.25.9 0l3.36-3.36c.56-.56 1.3-.85 2.07-.83.75.02 1.46.33 2.01.88l2.63 2.63c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-2.63-2.63a.66.66 0 0 0-.46-.21c-.16 0-.28.05-.39.16l-3.36 3.36c-.57.57-1.32.85-2.06.85"
    }), /*#__PURE__*/_jsx("path", {
      d: "M25.86 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v20.57c0 1.89-1.54 3.43-3.43 3.43M5.29 4.14c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H5.29Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.57 20.14h-16a1.14 1.14 0 1 1 0-2.28h16a1.14 1.14 0 1 1 0 2.28M23.57 24.71h-16a1.14 1.14 0 1 1 0-2.28h16a1.14 1.14 0 1 1 0 2.28"
    })]
  }));
};
ContentIcon.displayName = 'ContentIcon';